import { MAX_SEARCH_CONDITION } from '@doda/common/src/logics/cookie';
import { createSearchConditionLabelRequestParams } from '@doda/common/src/logics/createSearchConditionLabelRequestParams';
import { getSearchConditionLabel } from '@doda/common/src/services/getSearchConditionLabelAPI';
import { getCookie } from '@doda/common/src/utils/cookieUtil';
import { generateDateText } from '@doda/common/src/utils/dateUtil';
import { SearchConditionDataType } from 'components/FollowSearchResultsNavigation/types';
import { useEffect, useState } from 'react';

/**
 * 最近検索した条件
 * @returns 最近検索した条件データと更新関数
 */
export const useSearchedCondition = () => {
  const [searchConditionList, setSearchConditionList] = useState<
    SearchConditionDataType[]
  >([]);

  useEffect(() => {
    (async () => {
      const promises: SearchConditionDataType[] = [];
      for (let i = 1; i <= MAX_SEARCH_CONDITION; i += 1) {
        const targetCookie = `search_condition${i}`;
        const targetCookieValue = getCookie(targetCookie);

        // eslint-disable-next-line no-continue
        if (targetCookieValue === '') continue;

        try {
          const params =
            createSearchConditionLabelRequestParams(targetCookieValue);
          // eslint-disable-next-line no-await-in-loop
          const labelData = await getSearchConditionLabel(params);
          // search_conditionから日付を取得
          const dt = targetCookieValue
            .split('&')
            .find((item) => item.startsWith('dt='))
            ?.split('=')[1];
          promises.push({
            id: i,
            labelData,
            saveDate: generateDateText(dt ?? ''),
          });
        } catch {
          window.DD_LOGS?.logger.error({
            message: `検索条件ラベル取得の失敗 targetCookie:${targetCookie} value:${targetCookieValue}`,
          });
        }
      }
      setSearchConditionList(promises);
    })();
  }, []);

  // 最近検索した条件データの更新処理
  const updateSearchConditionList = (list: SearchConditionDataType[]) => {
    setSearchConditionList(list);
  };

  return {
    searchConditionList,
    updateSearchConditionList,
  };
};
